import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import Header from '../components/Header';
import Nav from '../components/Nav';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';

import "chart.js/auto";
import { Bar } from 'react-chartjs-2';
import axios from 'axios';
import { dateFormat, endpoint, endpointApi } from '../utils';
import { logout } from '../redux/actions/auth.action';
import { setLoading } from '../redux/actions/loader.action';

export default function HomePage() {
  const jwt_access = localStorage.getItem('jwt_access');
  const { me } = useSelector(state => state.auth);
  const { loading } = useSelector(state => state.loader);
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const detailsOrderModal = useRef(null);
  const detailsClientModal = useRef(null);
  const detailsInvoiceModal = useRef(null);
  const detailsPackagingModal = useRef(null);

  const [order, setOrder] = useState(null);
  const [client, setClient] = useState(null);
  const [invoice, setInvoice] = useState(null);
  const [packaging, setPackaging] = useState(null);
  
  const [year, setYear] = useState((new Date()).getFullYear());
  const [yearsOptions, setYearsOptions] = useState([]);

  const [modal, setModal] = useState(null);
  const [actionModal, setActionModal] = useState(null);
  const [data, setData] = useState(null);
  const [dataLoader, setDataLoader] = useState(false);
  const [stats, setStats] = useState(null);
  const [statLoader, setStatLoader] = useState(false);
  const [lastOrders, setLastOrders] = useState([]);
  const [lastOrderLoader, setLastOrderLoader] = useState(false);
  const [nextDelivryNotes, setNextDelivryNotes] = useState([]);
  const [nextDelivryNoteLoader, setNextDelivryNoteLoader] = useState(false);
  const [upcomingInvoices, setUpcomingInvoices] = useState([]);
  const [upcomingInvoiceLoader, setUpcomingInvoiceLoader] = useState(false);
  const [unpaidInvoices, setUnpaidInvoices] = useState([]);
  const [unpaidInvoiceLoader, setUnpaidInvoiceLoader] = useState(false);
  const [packagings, setPackagings] = useState([]);
  const [packagingLoader, setPackagingLoader] = useState(false);
  const [clients, setClients] = useState([]);
  const [clientLoader, setClientLoader] = useState(false);
  const [sales, setSales] = useState([]);
  const [saleLoader, setSaleLoader] = useState(false);
  const [totalAmounts, setTotalAmounts] = useState([]);
  const [totalAmountsData, setTotalAmountsData] = useState([]);
  const [totalAmountLoader, setTotalAmountLoader] = useState(false);
  const [salesConfig, setSalesConfig] = useState(null);

  const getStats = useCallback(async (year=null) => {
    try {
      setStatLoader(true);
      year = year ? year : (new Date()).getFullYear();
      const { data } = await axios.get(`${ endpointApi }getStats?year=${ year }`, {
        headers: {
          'Authorization': `Bearer ${ jwt_access }`
        }
      });

      setStats(data);
      setStatLoader(false);
    } catch (error) {
      setStatLoader(false);
      if(error.response.status === 401){
        dispatch(logout(location.pathname + location.search, navigate));
      }
    }
  }, [jwt_access, dispatch, location, navigate]);

  const getLastOrders = useCallback(async () => {
    try {
      setLastOrderLoader(true);
      const { data } = await axios.get(`${ endpointApi }getLastOrders?limit=10`, {
        headers: {
          'Authorization': `Bearer ${ jwt_access }`
        }
      });

      setLastOrders(data);
      setLastOrderLoader(false);
    } catch (error) {
      setLastOrderLoader(false);
      if(error.response.status === 401){
        dispatch(logout(location.pathname + location.search, navigate));
      }
    }
  }, [jwt_access, dispatch, location, navigate]);
  
  const getNextDelivryNotes = useCallback(async () => {
    try {
      setNextDelivryNoteLoader(true);
      const { data } = await axios.get(`${ endpointApi }getNextDelivryNotes?limit=10`, {
        headers: {
          'Authorization': `Bearer ${ jwt_access }`
        }
      });

      setNextDelivryNotes(data);
      setNextDelivryNoteLoader(false);
    } catch (error) {
      setNextDelivryNoteLoader(false);
      if(error.response.status === 401){
        dispatch(logout(location.pathname + location.search, navigate));
      }
    }
  }, [jwt_access, dispatch, location, navigate]);
  
  const getUpcomingInvoices = useCallback(async () => {
    try {
      setUpcomingInvoiceLoader(true);
      const { data } = await axios.get(`${ endpointApi }getUpcomingInvoices?limit=10`, {
        headers: {
          'Authorization': `Bearer ${ jwt_access }`
        }
      });

      setUpcomingInvoices(data);
      setUpcomingInvoiceLoader(false);
    } catch (error) {
      setUpcomingInvoiceLoader(false);
      if(error.response.status === 401){
        dispatch(logout(location.pathname + location.search, navigate));
      }
    }
  }, [jwt_access, dispatch, location, navigate]);
  
  const getUnpaidInvoices = useCallback(async () => {
    try {
      setUnpaidInvoiceLoader(true);
      const { data } = await axios.get(`${ endpointApi }getUnpaidInvoices?limit=10`, {
        headers: {
          'Authorization': `Bearer ${ jwt_access }`
        }
      });

      setUnpaidInvoices(data);
      setUnpaidInvoiceLoader(false);
    } catch (error) {
      setUnpaidInvoiceLoader(false);
      if(error.response.status === 401){
        dispatch(logout(location.pathname + location.search, navigate));
      }
    }
  }, [jwt_access, dispatch, location, navigate]);
  
  const getOutStockPackagings = useCallback(async () => {
    try {
      setPackagingLoader(true);
      const { data } = await axios.get(`${ endpointApi }getOutStockPackagings?limit=10`, {
        headers: {
          'Authorization': `Bearer ${ jwt_access }`
        }
      });

      setPackagings(data);
      setPackagingLoader(false);
    } catch (error) {
      setPackagingLoader(false);
      if(error.response.status === 401){
        dispatch(logout(location.pathname + location.search, navigate));
      }
    }
  }, [jwt_access, dispatch, location, navigate]);
  
  const getNextOrderClients = useCallback(async () => {
    try {
      setPackagingLoader(true);
      const { data } = await axios.get(`${ endpointApi }getNextOrderClients?limit=10`, {
        headers: {
          'Authorization': `Bearer ${ jwt_access }`
        }
      });

      setClients(data);
      setClientLoader(false);
    } catch (error) {
      setClientLoader(false);
      if(error.response.status === 401){
        dispatch(logout(location.pathname + location.search, navigate));
      }
    }
  }, [jwt_access, dispatch, location, navigate]);

  const getOrdersByMonth = useCallback(async (year=null) => {
    try {
      setDataLoader(true);
      setData(null)
      year = year ? year : (new Date()).getFullYear();
      const { data } = await axios.get(`${ endpointApi }getOrdersByMonth?year=${ year }`, {
        headers: {
          'Authorization': `Bearer ${ jwt_access }`
        }
      });

      const dt = {
        labels: data.labels,
        datasets: [
          {
            label: 'Nombre de commandes',
            data: data.data,
            backgroundColor: "#0975a3",
            borderColor: "#0975a3",
            borderWidth: 1,
          },
        ],
      };
      setData(dt);
      setDataLoader(false);
    } catch (error) {
      setDataLoader(false);
      if(error.response.status === 401){
        dispatch(logout(location.pathname + location.search, navigate));
      }
    }
  }, [jwt_access, dispatch, location, navigate]);
  
  const getTotalAmountByMonth = useCallback(async (year=null) => {
    try {
      setTotalAmountLoader(true);
      setTotalAmountsData(null)
      year = year ? year : (new Date()).getFullYear();
      const { data } = await axios.get(`${ endpointApi }getTotalAmountByMonth?year=${ year }`, {
        headers: {
          'Authorization': `Bearer ${ jwt_access }`
        }
      });

      setTotalAmountsData(data);
      setTotalAmountLoader(false);
    } catch (error) {
      setTotalAmountLoader(false);
      if(error.response && error.response.status === 401){
        dispatch(logout(location.pathname + location.search, navigate));
      }
    }
  }, [jwt_access, dispatch, location, navigate]);

  const getSalesByMonth = useCallback(async (year=null) => {
    try {
      setSaleLoader(true);
      setSales(null)
      year = year ? year : (new Date()).getFullYear();
      const { data } = await axios.get(`${ endpointApi }getSalesByMonth?year=${ year }`, {
        headers: {
          'Authorization': `Bearer ${ jwt_access }`
        }
      });

      setSales(data);
      setSaleLoader(false);
    } catch (error) {
      setSaleLoader(false);
      if(error.response && error.response.status === 401){
        dispatch(logout(location.pathname + location.search, navigate));
      }
    }
  }, [jwt_access, dispatch, location, navigate]);

  useEffect(() => {
    getLastOrders();
    getNextDelivryNotes();
    getUpcomingInvoices();
    getUnpaidInvoices();
    getStats();
    getOrdersByMonth();
    getOutStockPackagings();
    getNextOrderClients();
    getSalesByMonth();
    getTotalAmountByMonth();
  }, [location, getLastOrders, getNextDelivryNotes, getUpcomingInvoices, getUnpaidInvoices, getStats, getOutStockPackagings, getNextOrderClients, getOrdersByMonth, getSalesByMonth, getTotalAmountByMonth]);

  useEffect(() => {
    dispatch(setLoading(lastOrderLoader || nextDelivryNoteLoader || upcomingInvoiceLoader || unpaidInvoiceLoader || statLoader || packagingLoader || clientLoader || dataLoader || saleLoader || totalAmountLoader));
  }, [lastOrderLoader, nextDelivryNoteLoader, upcomingInvoiceLoader, unpaidInvoiceLoader, statLoader, packagingLoader, clientLoader, dataLoader, saleLoader, totalAmountLoader, dispatch]);

  useEffect(() => {
    const clickOutsideActionModal = (e) => {
      const $actionModals = document.querySelectorAll('.actions>ul');
      $actionModals.forEach($actionModal => {
        if($actionModal && !$actionModal.contains(e.target) && $actionModal.classList.contains('active')){
          setActionModal(null);
        }
      });
    }
    document.addEventListener('click', clickOutsideActionModal);
    return () => {
      document.removeEventListener('click', clickOutsideActionModal);
    }
  }, []);

  useEffect(() => {
    const clickOutsideModal = (e) => {
      if(detailsOrderModal.current === e.target || detailsInvoiceModal.current === e.target || detailsClientModal.current === e.target || detailsPackagingModal.current === e.target || e.target.classList.contains('_modal-close')){
        setModal(null);
      }
    }

    document.addEventListener('click', clickOutsideModal);

    return () => {
      document.removeEventListener('click', clickOutsideModal);
    }
  }, []);

  useEffect(() => {
    if(modal === null){
      setOrder(null);
      setClient(null);
      setInvoice(null);
      setPackaging(null);
    }
  }, [modal]);

  useEffect(() => {
    if((new Date()).getFullYear() > 2024){
      for(let i = (new Date()).getFullYear(); i >= 2024; i--){
        setYearsOptions(options => [...options, i]);
      }
    }else{
      setYearsOptions([2024]);
    }
  }, []);

  useEffect(() => {
    if(year === ""){
      setYear((new Date()).getFullYear());
    }else{
      getStats(year);
      getOrdersByMonth(year);
      getSalesByMonth(year);
      getTotalAmountByMonth(year);
    }
  }, [year, getStats, getOrdersByMonth, getSalesByMonth, getTotalAmountByMonth]);

  useEffect(() => {
    setTotalAmounts(null);
    if(totalAmountsData !== null && totalAmountsData.data){
      try {
        const config = {
          labels: totalAmountsData.labels,
          datasets: [
            {
              label: 'Chiffre d\'affaires en Ariary',
              data: totalAmountsData.data.amounts,
              backgroundColor: `#20c997`,
              tension: 0.1
            },
            {
              label: 'Dépenses en Ariary',
              data: totalAmountsData.data.expenses,
              backgroundColor: `#dc3545`,
              tension: 0.1
            },
          ],
          options: {
            responsive: true,
            scales: {
              x: {
                title: {
                  display: true,
                  text: 'Mois'
                }
              },
              y: {
                title: {
                  display: true,
                  text: 'Montants'
                }
              }
            }
          }
        };
        setTotalAmounts(config ? <Bar data={ config } height={ 80 } /> : null);
      } catch (error) {
        console.log(error)
      }
    }
  }, [totalAmountsData]);
  
  useEffect(() => {
    setSalesConfig(null);
    if(sales !== null && sales.data){
      try {
        const config = {
          labels: sales.labels,
          datasets: [
            {
              label: 'Nb de rambos vendus',
              data: sales.data.map(item => item.RAMBO),
              backgroundColor: `#20c997`,
              tension: 0.1
            },
            {
              label: 'Nb de bambous vendus',
              data: sales.data.map(item => item.BAMBOU),
              backgroundColor: `#dc3545`,
              tension: 0.1
            },
            {
              label: 'Nb de stylos vendus',
              data: sales.data.map(item => item.PEN),
              backgroundColor: `#ffc107`,
              tension: 0.1
            },
            {
              label: 'Nb de brosse à dents vendus',
              data: sales.data.map(item => item.TOOTHBRUSH),
              backgroundColor: `#0dcaf0`,
              tension: 0.1
            },
          ],
          options: {
            responsive: true,
            plugins: {
              legend: {
                position: 'top'
              },
              title: {
                display: true,
                text: 'Produits vendus'
              }
            },
            scales: {
              x: {
                title: {
                  display: true,
                  text: 'Mois'
                }
              },
              y: {
                title: {
                  display: true,
                  text: 'Nombre de pièces'
                }
              }
            }
          }
        };
  
        setSalesConfig(config ? <Bar data={ config } height={ 80 } /> : null);
      } catch (error) {
        console.log(error);
      }
    }
  }, [sales]);

  const f_eval = (val) => {
    return eval(val);
  }

  useEffect(() => {
    if(!jwt_access){
      navigate('/login?redirect_to=' + location.pathname + location.search);
    }
  }, [location, navigate, jwt_access]);

  return (
    me &&
    <HelmetProvider>
        <Helmet>
            <title>Tableau de bord - Société Mikalo</title>
        </Helmet>

        <Header />

        <Nav />

        <main id="main">
          <div className='title d-flex align-items-center justify-content-between'>
            <h1>Tableau de bord</h1>
            <form className='form'> 
              <label htmlFor='year'>Année:</label>
              <select className='form-control' required value={ year } onChange={ (e) => setYear(e.target.value) }>
                <option value="">Sélectionner...</option>
                { yearsOptions.map(year => {
                  return(
                    <option value={ year } key={ year }>{ year }</option>
                  )
                })}
              </select>
            </form>
          </div>

          <div className='text-end'>
            <a href={ `${ endpoint }export/products-sold-per-month/${ year }` } target='_blank' rel="noreferrer" className='btn btn-primary'><i className='fa fa-file-excel'></i> Télécharger le fichier Excel</a>
          </div>

          <div ref={ detailsOrderModal } className={ `_modal${ modal === 'details' && order ? ' active' : '' }` }>
            <div className='_modal-content'>
              <div className='_modal-head'>
                { order && 
                <h4>Commande N° { order.code }</h4> }
                <button type='button' className='_modal-close'>&times;</button>
              </div>
              <div className='_modal-body'>
                { order && <>
                  <div className='row'>
                    <div className='col-6 mb-3'>
                      <div className='_label'>Code</div>
                      <div className='_value'>{ order.code }</div>
                    </div>
                    <div className='col-6 mb-3'>
                      <div className='_label'>Date de commande</div>
                      <div className='_value'>{ dateFormat(order.order_date) }</div>
                    </div>
                  </div>
                  
                  <div className='mb-3'>
                    <div className='_label'>Bon de commande</div>
                    <div className='_value'>{ order.purchase_order ? order.purchase_order : "-" }</div>
                  </div>

                  <div className='mb-3'>
                    <div className='_label'>Client</div>
                    <div className='_value'>
                      { order.client ? (order.client.type === "Company" ? order.client.company_name : order.client.last_name + " " + order.client.first_name) : '-' }
                      <br/>
                      { order.client ? order.client.address + ", " + order.client.zipcode + " " + order.client.city + ", " + order.client.country : "-" }
                      <br/>
                      { order.client ? (order.client.email ? "E-mail: " : "") + order.client.email + (order.client.phone ? (order.client.email ? " - Tél: " : "Tél: ") + order.client.phone : "") + (order.client.website ? (order.client.email || order.client.phone ? " - Site web: " : "Site web: ") + order.client.website : "") : "-" }
                    </div>
                  </div>

                  <div className='row'>
                    <div className='col-6 mb-3'>
                      <div className='_label'>Montant</div>
                      <div className='_value'>{ new Intl.NumberFormat('fr-FR', {maximumFractionDigits: 2, minimumFractionDigits: 2}).format(order.total_amount) } Ariary</div>
                    </div>

                    <div className='col-6 mb-3'>
                      <div className='_label'>Etat</div>
                      <div className='_value'>{ order.status === "Confirmed" ? <span className='badge bg-info'>Confirmée</span> : (order.status === "Shipped" ? <span className='badge bg-success'>Expédiée</span> : ( order.status === "Delivered" ? <span className='badge bg-success'>Livrée</span> : (order.status === "Cancelled" ? <span className='badge bg-danger'>Annulée</span> : (order.status === "Returned" ? <span className='badge bg-dark'>Retournée</span> : <span className='badge bg-warning'>En attente</span>)))) }</div>
                    </div>
                  </div>

                  <div className='mb-3'>
                    <div className='_label'>Détails</div>
                    <div className='_value'>
                      <table className='table table-striped'>
                        <thead>
                          <tr>
                            <th>Produit</th>
                            <th>Quantité</th>
                            <th>Prix unit. (Ariary)</th>
                            <th>Montant HT (Ariary)</th>
                          </tr>
                        </thead>
                        <tbody>
                          { order.items.map((item, index) => {
                            return(
                            <tr key={ index }>
                              <td>{ item.product.code } - { item.product.name } - { item.product.subtitle }</td>
                              <td>{ item.quantity }{ item.product.unit ? ' ' + (item.product.unit === 'Item' ? 'pièce' : (item.product.unit === 'Box' ? 'boîte' : 'carton')) + (item.quantity > 1 ? 's' : '') : '' }</td>
                              <td>{ new Intl.NumberFormat('fr-FR', {maximumFractionDigits: 2, minimumFractionDigits: 2}).format(item.unit_price) }</td>
                              <td>{ new Intl.NumberFormat('fr-FR', {maximumFractionDigits: 2, minimumFractionDigits: 2}).format(item.unit_price * item.quantity) }</td>
                            </tr>
                            )
                          }) }
                          <tr>
                            <th colSpan={ 3 } className='text-uppercase'>Total</th>
                            <th>{ new Intl.NumberFormat('fr-FR', {maximumFractionDigits: 2, minimumFractionDigits: 2}).format(order.total_amount) }</th>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </> }
              </div>
            </div>
          </div>
          
          <div ref={ detailsClientModal } className={ `_modal${ modal === 'details' && client ? ' active' : '' }` }>
            <div className='_modal-content'>
              <div className='_modal-head'>
                  { client &&
                  <h4>{ client.code }</h4> }
                  <button className='_modal-close'>&times;</button>
              </div>
              <div className='_modal-body'>
              { client && <>
                  <div className='mb-3'>
                      <div className='_label'>Photo</div>
                      <div className='_value'>
                          <div className='avatar'>
                              { client.photo ?
                              <img src={ `${ endpoint }storage/${ client.photo }` } alt='' /> :
                              (client.type === "Company" ? client.company_name.charAt(0) : client.first_name.charAt(0))
                              }
                          </div>
                      </div>
                  </div>
                  <div className='mb-3'>
                      <div className='_label'>Code</div>
                      <div className='_value'>{ client.code }</div>
                  </div>
                  { client.type === 'Company' &&
                  <>
                      <div className='mb-3'>
                          <div className='_label'>Nom de l'entreprise</div>
                          <div className='_value'>{ client.code }</div>
                      </div>
                      <div className='mb-3'>
                          <div className='_label'>RCS</div>
                          <div className='_value'>{ client.rcs }</div>
                      </div>
                      <div className='mb-3'>
                          <div className='_label'>NIF</div>
                          <div className='_value'>{ client.nif }</div>
                      </div>
                      <div className='mb-3'>
                          <div className='_label'>STAT</div>
                          <div className='_value'>{ client.stat }</div>
                      </div>
                  </> }
                  <div className='mb-3'>
                      <div className='_label'>Nom de { client.type === 'Company' ? 'responsable' : 'client' }</div>
                      <div className='_value'>{ client.gender === 'f' ? 'Madame' : 'Monsieur' } { client.last_name } { client.first_name }</div>
                  </div>
                  <div className='mb-3'>
                      <div className='_label'>Adresse</div>
                      <div className='_value'>{ client.address && client.zipcode && client.city && client.country ? client.address + ", " + client.zipcode + " " + client.city + ", " + client.country : "-" }</div>
                  </div>
                  <div className='mb-3'>
                      <div className='_label'>Téléphone</div>
                      <div className='_value'>{ client.phone }</div>
                  </div>
                  <div className='mb-3'>
                      <div className='_label'>E-mail</div>
                      <div className='_value'>{ client.email ? client.email : "-" }</div>
                  </div>
                  <div className='mb-3'>
                      <div className='_label'>Site web</div>
                      <div className='_value'>{ client.website ? client.website : '-' }</div>
                  </div>
                </> }
              </div>
            </div>
          </div>
          
          <div ref={ detailsInvoiceModal } className={ `_modal${ modal === 'details' && invoice ? ' active' : '' }` }>
            <div className='_modal-content'>
              <div className='_modal-head'>
                { invoice && 
                <h4>Facture N° { invoice.code }</h4> }
                <button type='button' className='_modal-close'>&times;</button>
              </div>
              <div className='_modal-body'>
                { invoice && <>
                  <div className='row'>
                    <div className='col-6 mb-3'>
                      <div className='_label'>Code</div>
                      <div className='_value'>{ invoice.code }</div>
                    </div>

                    <div className='col-6 mb-3'>
                      <div className='_label'>Date de facture</div>
                      <div className='_value'>{ dateFormat(invoice.date) }</div>
                    </div>
                  </div>

                  <div className='mb-3'>
                    <div className='_label'>Date d'écheance de la facture</div>
                    <div className='_value'>{ dateFormat(invoice.due_date) }</div>
                  </div>

                  <div className='mb-3'>
                    <div className='_label'>Client</div>
                    <div className='_value'>
                      { invoice.order && invoice.order.client ? (invoice.order.client.type === "Company" ? invoice.order.client.company_name : invoice.order.client.last_name + " " + invoice.order.client.first_name) : '-' }
                      <br/>
                      { invoice.order.client ? invoice.order.client.address + ", " + invoice.order.client.zipcode + " " + invoice.order.client.city + ", " + invoice.order.client.country : "-" }
                      <br/>
                      { invoice.order.client ? (invoice.order.client.email ? "E-mail: " : "") + invoice.order.client.email + (invoice.order.client.phone ? (invoice.order.client.email ? " - Tél: " : "Tél: ") + invoice.order.client.phone : "") + (invoice.order.client.website ? (invoice.order.client.email || invoice.order.client.phone ? " - Site web: " : "Site web: ") + invoice.order.client.website : "") : "-" }
                    </div>
                  </div>

                  <div className='row'>
                    <div className='col-6 mb-3'>
                      <div className='_label'>Montant</div>
                      <div className='_value'>{ new Intl.NumberFormat('fr-FR', {maximumFractionDigits: 2, minimumFractionDigits: 2}).format(f_eval(invoice.order.total_amount + '+' + invoice.withdrawal_fees_via_mvola + '+' + invoice.delivry_fees + '+' + invoice.shipping_fees)) } Ariary</div>
                    </div>

                    <div className='col-6 mb-3'>
                      <div className='_label'>Etat</div>
                      <div className='_value'>{ invoice.status === "Sent" ? <span className="badge bg-info">Envoyée</span> : (invoice.status === "Paid" ? <span className="badge bg-success">Payée</span> : (invoice.status === "Overdue" ? <span className="badge bg-danger">En retard</span> : (invoice.status === "Cancelled" ? <span className="badge bg-dark">Annulée</span> : (invoice.status === "Refunded" ? <span className="badge bg-danger">Remboursée</span> : <span className="badge bg-warning">En attente</span> ))))}</div>
                    </div>
                  </div>

                  <div className='mb-3'>
                    <div className='_label'>Détails{ invoice && invoice.order ? ' (Commande N° ' + invoice.order.code + ')' : '' }</div>
                    <div className='_value'>
                      <table className='table table-striped'>
                        <thead>
                          <tr>
                            <th>Produit</th>
                            <th>Quantité</th>
                            <th>Prix unit. (Ariary)</th>
                            <th>Montant HT (Ariary)</th>
                          </tr>
                        </thead>
                        <tbody>
                          { invoice && invoice.items.map((item, index) => {
                            return(
                              <tr key={ index }>
                                <td>{ item.product.code } - { item.product.name } - { item.product.subtitle }</td>
                                <td>{ item.quantity }{ item.product.unit ? ' ' + (item.product.unit === 'Item' ? 'pièce' : (item.product.unit === 'Box' ? 'boîte' : 'carton')) + (item.quantity > 1 ? 's' : '') : '' }</td>
                                <td>{ new Intl.NumberFormat('fr-FR', {maximumFractionDigits: 2, minimumFractionDigits: 2}).format(item.unit_price) }</td>
                                <td>{ new Intl.NumberFormat('fr-FR', {maximumFractionDigits: 2, minimumFractionDigits: 2}).format(item.unit_price * item.quantity) }</td>
                              </tr>
                            )
                          }) }
                          { invoice.withdrawal_fees_via_mvola &&
                          <tr>
                            <td colSpan={ 3 }>Frais de retrait via mvola</td>
                            <td>{ new Intl.NumberFormat('fr-FR', {maximumFractionDigits: 2, minimumFractionDigits: 2}).format(invoice.withdrawal_fees_via_mvola) }</td>
                          </tr> }
                          { invoice.delivry_fees &&
                          <tr>
                            <td colSpan={ 3 }>Frais de livraison</td>
                            <td>{ new Intl.NumberFormat('fr-FR', {maximumFractionDigits: 2, minimumFractionDigits: 2}).format(invoice.delivry_fees) }</td>
                          </tr> }
                          { invoice.shipping_fees &&
                          <tr>
                            <td colSpan={ 3 }>Frais d'envoi</td>
                            <td>{ new Intl.NumberFormat('fr-FR', {maximumFractionDigits: 2, minimumFractionDigits: 2}).format(invoice.shipping_fees) }</td>
                          </tr> }
                          <tr>
                            <th colSpan={ 3 } className='text-uppercase'>Total</th>
                            <th>{ new Intl.NumberFormat('fr-FR', {maximumFractionDigits: 2, minimumFractionDigits: 2}).format(f_eval(invoice.order.total_amount + '+' + invoice.withdrawal_fees_via_mvola + '+' + invoice.delivry_fees + '+' + invoice.shipping_fees)) }</th>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <div className='text-center pt-2'>
                    <a href={ `${ endpoint }invoice/${ invoice.id }/download` } target='_blank' rel="noreferrer" className='btn btn-lg btn-orange me-3' onClick={ () => setModal("edit") }><i className='fa fa-download'></i> Télécharger</a>
                  </div>
                </> }
              </div>
            </div>
          </div>
          
          <div ref={ detailsPackagingModal } className={ `_modal${ modal === 'details' && packaging ? ' active' : '' }` }>
            <div className='_modal-content'>
              { packaging && <>
                <div className='_modal-head'>
                    { packaging &&
                    <h4>{ packaging.code + " - " + packaging.name }</h4> }
                    <button className='_modal-close'>&times;</button>
                </div>
                <div className='_modal-body'>
                { packaging && <>
                    <div className='mb-3'>
                        <div className='_label'>Code</div>
                        <div className='_value'>{ packaging.code }</div>
                    </div>
                    <div className='mb-3'>
                        <div className='_label'>Nom de packaging</div>
                        <div className='_value'>{ packaging.name }</div>
                    </div>
                    <div className='row'>
                        <div className='col-6 mb-3'>
                            <div className='_label'>Quantité</div>
                            <div className='_value'>{ packaging.quantity }{ packaging.unit ? ' ' + (packaging.unit === 'Item' ? 'pièce' : (packaging.unit === 'Box' ? 'boîte' : 'carton')) + (packaging.quantity > 1 ? 's' : ''): "" }</div>
                        </div>
                        <div className='col-6 mb-3'>
                            <div className='_label'>Stock de sécurité</div>
                            <div className='_value'>{ packaging.safety_stock_level }{ packaging.unit ? ' ' + (packaging.unit === 'Item' ? 'pièce' : (packaging.unit === 'Box' ? 'boîte' : 'carton')) + (packaging.quantity > 1 ? 's' : ''): "" }</div>
                        </div>
                    </div>
                    <div className='mb-3'>
                        <div className='_label'>Etat</div>
                        <div className='_value'>{ packaging.safety_stock_level > 0 ? (packaging.quantity <= packaging.safety_stock_level ? <span className='badge bg-danger'>En rupture de stock</span> : <span className='badge bg-success'>En stock</span>) : '-' }</div>
                    </div>
                    <div className='pt-2 text-center'>
                        <button type='button' className='btn btn-lg btn-primary me-3' onClick={ () => {
                            setModal("operation")
                        } }><i className='fa fa-plus-minus'></i> Faire une opération</button>
                        <button type='button' className='btn btn-lg btn-primary' onClick={ () => {
                            setModal("update")
                        } }><i className='fa fa-edit'></i> Modifier</button>
                    </div>
                  </> }
                </div>
              </> }
            </div>
          </div>

          { loading === false && stats && <>
            <h3 className='subtitle'>L'année { year } en quelques chiffres</h3>
            <div className='row'>
              <div className='col-12 col-sm-6 col-md-4 col-lg-3'>
                <div className='box stat stat-1'>
                  <div className='stat-icon'><i className='fa fa-money-bill'></i></div>
                  <div className='stat-value'>{ new Intl.NumberFormat('fr-FR', {maximumFractionDigits: 2, minimumFractionDigits: 2}).format(stats.total_amount > 1000000 ? (stats.total_amount / 1000000) : (stats.total_amount / 1000)) } { stats.total_amount > 1000000 ? 'M' : 'k' }</div>
                  <div className='stat-text'>d'Ariary de chiffre d'affaires</div>
                </div>
              </div>
              <div className='col-12 col-sm-6 col-md-4 col-lg-3'>
                <div className='box stat stat-4'>
                  <div className='stat-icon'><i className='fa fa-money-bill'></i></div>
                  <div className='stat-value'>{ new Intl.NumberFormat('fr-FR', {maximumFractionDigits: 2, minimumFractionDigits: 2}).format(stats.expense_total_amount > 1000000 ? (stats.expense_total_amount / 1000000) : (stats.expense_total_amount / 1000)) } { stats.expense_total_amount > 1000000 ? 'M' : 'k' }</div>
                  <div className='stat-text'>d'Ariary de dépenses</div>
                </div>
              </div>
              <div className='col-12 col-sm-6 col-md-4 col-lg-3'>
                <div className='box stat stat-2'>
                  <div className='stat-icon'><i className='fa fa-file-invoice'></i></div>
                  <div className='stat-value'>{ new Intl.NumberFormat('fr-FR', {maximumFractionDigits: 2, minimumFractionDigits: 2}).format(stats.unpaid_invoice_amount > 1000000 ? (stats.unpaid_invoice_amount / 1000000) : (stats.unpaid_invoice_amount / 1000)) } { stats.unpaid_invoice_amount > 1000000 ? 'M' : 'k' }</div>
                  <div className='stat-text'>d'Ariary de factures impayées</div>
                </div>
              </div>
              <div className='col-12 col-sm-6 col-md-4 col-lg-3'>
                <div className='box stat stat-3'>
                  <div className='stat-icon'><i className='fa fa-shopping-cart'></i></div>
                  <div className='stat-value'>{ new Intl.NumberFormat('fr-FR', {maximumFractionDigits: 0}).format(stats.nb_orders) }</div>
                  <div className='stat-text'>commande{ stats.nb_orders > 1 ? 's' : ''} reçue{ stats.nb_orders > 1 ? 's' : ''}</div>
                </div>
              </div>
            </div>
          </> }

          { data &&
          <div className='box p-3'><Bar data={ data } height={ 60  } /></div> }

          { totalAmounts && <div className='box p-3'>{ totalAmounts }</div> }

          { salesConfig && <div className='box p-3'>{ salesConfig }</div> }

          <h3 className='subtitle'>Commandes récentes</h3>
          <div className="box">
            <table className='table table-striped'>
              <thead>
                <tr>
                  <th width="140">Code</th>
                  <th width="140">Date</th>
                  <th>Client</th>
                  <th className="text-end" width="160">Montant</th>
                  <th width="150">Etat</th>
                  <th width="75" className="text-end">Actions</th>
                </tr>
              </thead>
              <tbody>
              { lastOrders.length === 0 && loading === false && <tr><td colSpan={ 6 }>Aucune commande récente</td></tr> }
              { loading === true && <tr><td colSpan={ 6 }>Chargement...</td></tr> }
              { loading === false && lastOrders.map(order => {
                return(
                <tr key={ order.id }>
                  <td>{ order.code }</td>
                  <td>{ dateFormat(order.order_date) }</td>
                  <td>{ order.client ? (order.client.type === "Company" ? order.client.company_name : order.client.last_name + " " + order.client.first_name) : '-' }</td>
                  <td className="text-end">{ new Intl.NumberFormat('fr-FR', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(order.total_amount) } Ariary</td>
                  <td>{ order.status === "Confirmed" ? <span className='badge bg-info'>Confirmée</span> : (order.status === "Shipped" ? <span className='badge bg-success'>Expédiée</span> : ( order.status === "Delivered" ? <span className='badge bg-success'>Livrée</span> : (order.status === "Cancelled" ? <span className='badge bg-danger'>Annulée</span> : (order.status === "Returned" ? <span className='badge bg-dark'>Retournée</span> : <span className='badge bg-warning'>En attente</span>)))) }</td>
                  <td className="text-end">
                    <div className='actions'>
                      <button type='button' className='toggle-action' onClick={ (e) => {
                        e.stopPropagation();
                        setActionModal(actionModal !== 'order-' + order.id ? 'order-' + order.id : null);
                      } }><i className='fa fa-ellipsis-v'></i></button>
                      <ul className={ actionModal === 'order-' + order.id ? 'active' : '' }>
                        <li><button type='button' onClick={ () => {
                          setActionModal(null);
                          setOrder(order);
                          setModal("details");
                        } }><i className="fa fa-eye"></i> Voir les détails</button></li>
                      </ul>
                    </div>
                  </td>
                </tr>
                )
              }) }
              </tbody>
            </table>
          </div>
          
          <h3 className='subtitle'>Clients à suivre pour Commande Prochaine</h3>
          <div className="box">
            <table className='table table-striped'>
              <thead>
                <tr>
                  <th width="140">Code</th>
                  <th width="140">Date de prévue</th>
                  <th>Client</th>
                  <th>Téléphone</th>
                  <th>E-mail</th>
                </tr>
              </thead>
              <tbody>
              { clients.length === 0 && loading === false && <tr><td colSpan={ 5 }>Aucun client trouvé</td></tr> }
              { loading === true && <tr><td colSpan={ 5 }>Chargement...</td></tr> }
              { loading === false && clients.map(client => {
                return(
                <tr key={ client.id }>
                  <td>{ client.code }</td>
                  <td>{ dateFormat(client.next_order_date) }</td>
                  <td>{ client ? (client.type === "Company" ? client.company_name : client.last_name + " " + client.first_name) : '-' }</td>
                  <td>{ client.phone ? client.phone : '-' }</td>
                  <td>{ client.email ? client.email : '-' }</td>
                </tr>
                )
              }) }
              </tbody>
            </table>
          </div>
            
          <h3 className='subtitle'>Commandes à livrer bientôt</h3>
          <div className="box">
          <table className='table table-striped'>
              <thead>
                <tr>
                  <th width="140">Code</th>
                  <th width="140">Date</th>
                  <th>Client</th>
                  <th>Adresse de livraison</th>
                  <th width="150">Etat</th>
                  <th width="75" className="text-end">Actions</th>
                </tr>
              </thead>
              <tbody>
                { nextDelivryNotes.length === 0 && loading === false && <tr><td colSpan={ 6 }>Aucune commande à livrer bientôt</td></tr> }
                { loading === true && <tr><td colSpan={ 6 }>Chargement...</td></tr> }
                { loading === false && nextDelivryNotes.map(delivryNote => {
                  return(
                  <tr key={ delivryNote.id }>
                    <td>{ delivryNote.code }</td>
                    <td>{ dateFormat(delivryNote.date) }</td>
                    <td>{ delivryNote.order && delivryNote.order.client ? (delivryNote.order.client.type === 'Company' ? delivryNote.order.client.company_name : delivryNote.order.client.last_name + ' ' + delivryNote.order.client.first_name) : '-' }</td>
                    <td>{ delivryNote.address }</td>
                    <td>{ delivryNote.status === "Shipped" ? <span className="badge bg-info">Expédié</span> : (delivryNote.status === "Delivered" ?  <span className="badge bg-success">Livré</span> : (delivryNote.status === "Failed" ? <span className="badge bg-danger">Echec de la livraison</span> : (delivryNote.status === "Cancelled" ? <span className="badge bg-dark">Annulé</span> : (delivryNote.status === "PartiallyDelivered" ? <span className="badge bg-info">Partielement livré</span> : <span className="badge bg-warning">En attente</span> )))) }</td>
                    <td className="text-end">
                      <div className='actions'>
                        <button type='button' className='toggle-action' onClick={ (e) => {
                          e.stopPropagation();
                          setActionModal(actionModal !== 'delivry_note-' + delivryNote.id ? 'delivry_note-' + delivryNote.id : null);
                        } }><i className='fa fa-ellipsis-v'></i></button>
                        <ul className={ actionModal === 'delivry_note-' + delivryNote.id ? 'active' : '' }>
                          <li><button type='button' onClick={ () => {
                            setActionModal(null);
                            setClient(client);
                            setModal("details");
                          } }><i className="fa fa-eye"></i> Voir les détails</button></li>
                        </ul>
                      </div>
                    </td>
                  </tr>
                  )
                }) }
              </tbody>
            </table>
          </div>
          
          <h3 className='subtitle'>Factures à échéance prochaine</h3>
          <div className="box">
            <table className='table table-striped'>
              <thead>
                <tr>
                  <th width="140">Code</th>
                  <th width="140">Date</th>
                  <th width="140">Date d'échéance</th>
                  <th>Client</th>
                  <th className="text-end">Montant</th>
                  <th width="150">Etat</th>
                  <th width="75" className='text-end'>Actions</th>
                </tr>
              </thead>
              <tbody>
                { upcomingInvoices.length === 0 && loading === false && <tr><td colSpan={ 7 }>Aucune facture à échéance prochaine</td></tr> }
                { loading === true && <tr><td colSpan={ 7 }>Chargement...</td></tr> }
                { loading === false && upcomingInvoices.map(invoice => {
                  return(
                    <tr key={ invoice.id }>
                      <td>{ invoice.code }</td>
                      <td>{ dateFormat(invoice.date) }</td>
                      <td>{ dateFormat(invoice.due_date) }</td>
                      <td>{ invoice.order && invoice.order.client ? (invoice.order.client.type === 'Company' ? invoice.order.client.company_name : invoice.order.client.last_name + ' ' + invoice.order.client.first_name) : '-' }</td>
                      <td className="text-end">{ new Intl.NumberFormat('fr-FR', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(f_eval(invoice.order.total_amount + '+' + invoice.withdrawal_fees_via_mvola + '+' + invoice.delivry_fees + '+' + invoice.shipping_fees)) } Ariary</td>
                      <td>{ invoice.status === "Sent" ? <span className="badge bg-info">Envoyée</span> : (invoice.status === "Paid" ? <span className="badge bg-success">Payée</span> : (invoice.status === "Overdue" ? <span className="badge bg-danger">En retard</span> : (invoice.status === "Cancelled" ? <span className="badge bg-dark">Annulée</span> : (invoice.status === "Refunded" ? <span className="badge bg-danger">Remboursée</span> : <span className="badge bg-warning">En attente</span> ))))}</td>
                      <td className="text-end">
                        <div className='actions'>
                          <button type='button' className='toggle-action' onClick={ (e) => {
                            e.stopPropagation();
                            setActionModal(actionModal !== 'upcoming_invoice-' + invoice.id ? 'upcoming_invoice-' + invoice.id : null);
                          } }><i className='fa fa-ellipsis-v'></i></button>
                          <ul className={ actionModal === 'upcoming_invoice-' + invoice.id ? 'active' : '' }>
                            <li><button type='button' onClick={ () => {
                              setActionModal(null);
                              setInvoice(invoice);
                              setModal("details");
                            } }><i className="fa fa-eye"></i> Voir les détails</button></li>
                            <li><a href={ `${ endpoint }invoice/${ invoice.id }/download` } target='_blank' rel="noreferrer"  onClick={ () => {
                              setActionModal(null);
                            } }><i className="fa fa-download"></i> Télécharger</a></li>
                          </ul>
                        </div>
                      </td>
                    </tr>
                  )
                }) }
              </tbody>
            </table>
          </div>
              
          <h3 className='subtitle'>Factures impayées</h3>
          <div className="box">
            <table className='table table-striped'>
              <thead>
                <tr>
                  <th width="140">Code</th>
                  <th width="140">Date</th>
                  <th width="140">Date d'échéance</th>
                  <th>Client</th>
                  <th className="text-end">Montant</th>
                  <th width="150">Etat</th>
                  <th width="75" className='text-end'>Actions</th>
                </tr>
              </thead>
              <tbody>
                { unpaidInvoices.length === 0 && loading === false && <tr><td colSpan={ 7 }>Aucune facture à échéance prochaine</td></tr> }
                { loading === true && <tr><td colSpan={ 7 }>Chargement...</td></tr> }
                { loading === false && unpaidInvoices.map(invoice => {
                  return(
                    <tr key={ invoice.id }>
                      <td>{ invoice.code }</td>
                      <td>{ dateFormat(invoice.date) }</td>
                      <td>{ dateFormat(invoice.due_date) }</td>
                      <td>{ invoice.order && invoice.order.client ? (invoice.order.client.type === 'Company' ? invoice.order.client.company_name : invoice.order.client.last_name + ' ' + invoice.order.client.first_name) : '-' }</td>
                      <td className="text-end">{ new Intl.NumberFormat('fr-FR', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(f_eval(invoice.order.total_amount + '+' + invoice.withdrawal_fees_via_mvola + '+' + invoice.delivry_fees + '+' + invoice.shipping_fees)) } Ariary</td>
                      <td>{ invoice.status === "Sent" ? <span className="badge bg-info">Envoyée</span> : (invoice.status === "Paid" ? <span className="badge bg-success">Payée</span> : (invoice.status === "Overdue" ? <span className="badge bg-danger">En retard</span> : (invoice.status === "Cancelled" ? <span className="badge bg-dark">Annulée</span> : (invoice.status === "Refunded" ? <span className="badge bg-danger">Remboursée</span> : <span className="badge bg-warning">En attente</span> ))))}</td>
                      <td className="text-end">
                        <div className='actions'>
                          <button type='button' className='toggle-action' onClick={ (e) => {
                            e.stopPropagation();
                            setActionModal(actionModal !== 'unpaid_invoice-' + invoice.id ? 'unpaid_invoice-' + invoice.id : null);
                          } }><i className='fa fa-ellipsis-v'></i></button>
                          <ul className={ actionModal === 'unpaid_invoice-' + invoice.id ? 'active' : '' }>
                            <li><button type='button' onClick={ () => {
                              setActionModal(null);
                              setInvoice(invoice);
                              setModal("details");
                            } }><i className="fa fa-eye"></i> Voir les détails</button></li>
                            <li><a href={ `${ endpoint }invoice/${ invoice.id }/download` } target='_blank' rel="noreferrer"  onClick={ () => {
                              setActionModal(null);
                            } }><i className="fa fa-download"></i> Télécharger</a></li>
                          </ul>
                        </div>
                      </td>
                    </tr>
                  )
                }) }
              </tbody>
            </table>
          </div>

          { loading === false && packagings.length > 0 && <>
            <h3 className='subtitle'>Packagings en Rupture de Stock</h3>
            <div className='box'>
              <table className='table table-striped'>
                <thead>
                  <tr>
                    <th width="100">Code</th>
                    <th>Nom du packaging</th>
                    <th className='text-center'>Stock de sécurité</th>
                    <th className="text-center">Quantité</th>
                    <th width="150">Etat</th>
                    <th width="75" className="text-end">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  { packagings.map((item, index) => {
                  return (
                  <tr key={ index }>
                    <td>{ item.code }</td>
                    <td>{ item.name }</td>
                    <td className='text-center'>{ item.safety_stock_level }</td>
                    <td className="text-center">{ item.quantity }{ item.unit ? ' ' + (item.unit === 'Item' ? 'pièce' : (item.unit === 'Box' ? 'boîte' : 'carton')) + (item.quantity > 1 ? 's' : '') : '' }</td>
                    <td>{ item.safety_stock_level > 0 ? (item.quantity <= item.safety_stock_level ? <span className='badge bg-danger'>En rupture de stock</span> : <span className='badge bg-success'>En stock</span>) : "-" }</td>
                    <td className="text-end">
                      <div className='actions'>
                        <button type='button' className='toggle-action' onClick={ (e) => {
                          e.stopPropagation();
                          setActionModal(actionModal !== 'packaging-' + item.id ? 'packaging-' + item.id : null);
                        } }><i className='fa fa-ellipsis-v'></i></button>
                        <ul className={ actionModal === 'packaging-' + item.id ? 'active' : '' }>
                          <li><button type='button' onClick={ () => {
                            setActionModal(null);
                          } }><i className="fa fa-eye"></i> Voir les détails</button></li>
                          <li><button type='button' onClick={ () => {
                            setActionModal(null);
                          } }><i className="fa fa-edit"></i> Modifier</button></li>
                        </ul>
                      </div>
                    </td>
                  </tr> ) })}
                </tbody>
            </table>
            </div>
          </> }
        </main>
    </HelmetProvider>
  )
}
